import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./slices/user";
import messageReducer from "./slices/messages";
import memberSlice from "./slices/member";
import jobSlice from "./slices/jobs";
import postSlice from "./slices/posts";
import adsSlice from "./slices/advertisements";
import gallerySlice from "./slices/gallery";

const reducer = {
  auth: authReducer,
  message: messageReducer,
  member: memberSlice,
  jobs: jobSlice,
  posts: postSlice,
  advertisement: adsSlice,
  gallery: gallerySlice
}

const store = configureStore({
  reducer: reducer,
  devTools: true,
})

export default store;
